'use strict';

const { hydrate } = require('@grpn/hydration');

const CarouselV2 = require('./carousel');

module.exports = hydrate('CarouselV2', CarouselV2);
